<template>
  <BlockContainer class="p-5">
    <h5>Leiekontrakter</h5>

    <div v-if="!loaded" class="text-center mt-5 pt-5 mb-5 pb-5">
      <hl-Loader></hl-Loader>
    </div>
    <div v-else>
      <div v-if="contracts.length" class="table-responsive mt-5">
        <table class="table table-hover">
          <thead>
            <tr>
              <!-- Disabled until fix
              <th scope="col">Påbegynt</th>
              -->
              <th scope="col">Leietaker</th>
              <th scope="col">Status</th>
              <th scope="col" class="text-center">Vis / endre</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(contract, i) in contracts" :key="i">
              <!--<td scope="row">
                <hl-Date :date="contract.startDate"></hl-Date>
              </td>-->
              <td>{{ contract.tenant }}</td>
              <td>{{ mapStatuses(contract.status) }}</td>
              <td class="text-center">
                <a v-if="contract.pdfUri" class="see-edit mr-2" :href="contract.pdfUri">
                  <i class="budicon-file"></i>
                </a>
                <a :href="contract.uri" class="see-edit">
                  <i class="budicon-chevron-right-circle"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-else class="mt-5">
        <hl-Alert variant="info" layout="vertical">
          <p>Funnet en leietaker? Opprett kontrakt i dag.</p>
          <a :href="createContractURL"><button class="btn btn-sm btn-light">Ny leiekontrakt</button></a>
        </hl-Alert>
      </div>
    </div>
  </BlockContainer>
</template>

<script>
import BlockContainer from '@/components/BlockContainer.vue';
import RedirectOperations from '@modules/husleie-framework/src/static-classes/RedirectOperations.class';
import { AppRedirect } from '@modules/husleie-framework/src/enums/AppRedirect.enum';
import { mapGetters } from 'vuex';
import Loader from '@modules/husleie-framework/src/components/loaders/Loader.vue';
import Alert from '@modules/husleie-framework/src/components/text/Alert.vue';

export default {
  components: {
    BlockContainer,
    'hl-Loader': Loader,
    'hl-Alert': Alert,
  },

  props: {
    rentalObjectId: [Number, String],
  },

  data() {
    return {
      statusList: [
        {
          name: 'Signert',
          value: 'signed',
        },
        {
          name: 'Venter på utleiers signatur',
          value: 'signing_landlord',
        },
        {
          name: 'Venter på leietakers signatur',
          value: 'signing_tenant',
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['getRentalObject', 'getRentalObjectTenancies', 'isExtendedRentalObjectLoaded']),

    createContractURL() {
      return RedirectOperations.getURL(AppRedirect.CONTRACT_CREATE, { rentalObjectId: this.rentalObjectId });
    },

    rentalObject() {
      return this.getRentalObject(this.rentalObjectId);
    },

    loaded() {
      return this.isExtendedRentalObjectLoaded;
    },

    rentalObjectContracts() {
      const products = [];

      for (const tenancy of this.getRentalObject(this.rentalObjectId).tenancies) {
        for (const product of tenancy.products) {
          if (product.name === 'contract-spa') {
            products.push(tenancy);
          }
        }
      }

      return products;
    },

    contracts() {
      const contracts = [];

      for (const tenancy of this.rentalObjectContracts) {
        for (const contract of tenancy.products) {
          if (contract.status !== 'signed') {
            continue;
          }
          contracts.push({
            startDate: tenancy.details.duration.start,
            tenant: tenancy.tenants[0].name,
            status: contract.status,
            uri: tenancy.details.uri,
            pdfUri: contract.pdfUri,
          });
        }
      }

      return contracts;
    },
  },

  methods: {
    mapStatuses(status) {
      for (const i of this.statusList) {
        if (i.value === status) {
          return i.name;
        }
      }
    },
  },
};
</script>
